export const SkeletonProjectCard = (props: { total?: number }) => {
  const { total = 5 } = props
  return (
    <>
      {Array.from({ length: total }).map((_, index) => (
        <div
          key={index}
          className="hover-project-card p-3 bg-white border border-[#E4E4E4] rounded-[6px] cursor-pointer flex flex-col gap-2"
        >
          <div className="h-[18px] w-full bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
          <div className="h-[24px] w-full bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
          <div className="h-[24px] w-[100px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
        </div>
      ))}
    </>
  )
}

export const SkeletonProjectDetail = () => {
  return (
    <div className="flex flex-col h-full w-full">
      <div className="min-h-[74px] border-b border-[#E4E4E4] flex items-center justify-between pl-[24px] pr-[24px]">
        <div className="flex items-center">
          <div className="h-[22px] w-[200px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
        </div>
        <div className="h-[35px] w-[120px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
      </div>
      <div className="flex flex-col flex-1 overflow-auto p-[24px] gap-[12px]">
        {Array.from({ length: 5 }).map((_, index) => (
          <div
            key={index}
            className="grid grid-cols-3 border border-[#E4E4E4] p-[12px] rounded-[6px]"
          >
            <div className="flex items-center">
              <div className="h-[24px] w-[24px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
              <div className="h-[22px] w-[100px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
            </div>
            <div className="flex items-center justify-center">
              <div className="h-[20px] w-[20px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
              <div className="h-[22px] w-[68px] bg-[#EFEFEF] rounded-full dark:bg-gray-700" />
            </div>
            <div className="flex items-center justify-end">
              <div className="h-[28px] w-[100px] bg-[#EFEFEF] rounded-[8px] dark:bg-gray-700" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
